import { render, staticRenderFns } from "./ActivitiesOverviewDealsDiscountsAndBirthdayClub.vue?vue&type=template&id=488e7164&scoped=true&"
import script from "./ActivitiesOverviewDealsDiscountsAndBirthdayClub.vue?vue&type=script&lang=ts&"
export * from "./ActivitiesOverviewDealsDiscountsAndBirthdayClub.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitiesOverviewDealsDiscountsAndBirthdayClub.vue?vue&type=style&index=0&id=488e7164&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "488e7164",
  null
  
)

export default component.exports